import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f671f1ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style/ck-content.css?vue&type=style&index=0&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=f671f1ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f671f1ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f671f1ec')) {
      api.createRecord('f671f1ec', component.options)
    } else {
      api.reload('f671f1ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f671f1ec&scoped=true", function () {
      api.rerender('f671f1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ckContent/index.vue"
export default component.exports